<article
  class="expansion-panel"
  [class.expansion-panel--collapsed]="isCollapsed"
  [class.expansion-panel--disabled]="disabled"
>
  <div class="expansion-panel__header">
    <button
      class="expansion-panel__trigger"
      type="button"
      [attr.aria-expanded]="!isCollapsed"
      [attr.aria-controls]="contentId"
      [disabled]="disabled"
      (click)="toggle()"
    >
      <span class="expansion-panel__title">{{ title }}</span>
    </button>

    <div class="expansion-panel__controls">
      <div class="expansion-panel__header-suffix">
        <ng-content
          select="[expansionPanelHeaderSuffix],[expansionPanelHeaderActions]"
        />
      </div>

      <button
        *ngIf="showChevron"
        class="expansion-panel__chevron-trigger"
        type="button"
        [attr.aria-expanded]="!isCollapsed"
        [attr.aria-controls]="contentId"
        [disabled]="disabled"
        (click)="toggle()"
      >
        <span class="visually-hidden">{{
          isCollapsed ? 'Expand' : 'Collapse'
        }}</span>
        <svg
          class="expansion-panel__chevron"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M4.6665 9.66667L7.99984 6.33334L11.3332 9.66667"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>

  <div
    class="expansion-panel__content"
    [id]="contentId"
    [attr.aria-hidden]="isCollapsed"
  >
    <div class="expansion-panel__content-inner">
      <ng-content />
    </div>
  </div>
</article>
